import React from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Box,
  Card,
  CardContent,
  Avatar
} from '@mui/material';
import { Google as GoogleIcon, FlightTakeoff } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

const LoginPage: React.FC = () => {
  const { signIn } = useAuth();

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={12} sx={{ 
          borderRadius: 4, 
          overflow: 'hidden',
          boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
        }}>
          {/* 헤더 섹션 */}
          <Box sx={{ 
            bgcolor: 'rgba(255,255,255,0.95)', 
            p: 5, 
            textAlign: 'center',
            position: 'relative'
          }}>
            <Avatar 
              sx={{ 
                bgcolor: '#667eea', 
                color: 'white', 
                width: 80, 
                height: 80, 
                margin: '0 auto',
                mb: 3,
                boxShadow: '0 8px 16px rgba(102,126,234,0.3)'
              }}
            >
              <FlightTakeoff sx={{ fontSize: 40 }} />
            </Avatar>
            
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                color: '#2d3748',
                fontWeight: 700,
                mb: 1,
                letterSpacing: '-0.5px'
              }}
            >
              에어제타
            </Typography>
            
            <Typography 
              variant="h6" 
              sx={{ 
                color: '#667eea',
                fontWeight: 500,
                mb: 1
              }}
            >
              항공보안교육훈련
            </Typography>
            
            <Typography 
              variant="subtitle1" 
              sx={{ 
                color: '#718096',
                fontWeight: 400
              }}
            >
              이수현황 통합 관리시스템
            </Typography>
          </Box>
          
          {/* 로그인 섹션 */}
          <CardContent sx={{ p: 5, bgcolor: '#fafafa' }}>
            <Typography 
              variant="body1" 
              color="textSecondary" 
              textAlign="center"
              paragraph 
              sx={{ mb: 4, lineHeight: 1.6 }}
            >
              시스템 접근을 위해<br />
              <strong>Google 계정</strong>으로 로그인해주세요
            </Typography>
            
            <Button
              variant="outlined"
              size="large"
              startIcon={<GoogleIcon />}
              onClick={signIn}
              fullWidth
              sx={{ 
                py: 1.8,
                borderRadius: 3,
                textTransform: 'none',
                fontSize: '1.1rem',
                fontWeight: 500,
                borderColor: '#e2e8f0',
                color: '#4a5568',
                backgroundColor: 'white',
                '&:hover': {
                  borderColor: '#667eea',
                  backgroundColor: 'rgba(102,126,234,0.04)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(102,126,234,0.2)'
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              Google 계정으로 로그인
            </Button>
            
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography 
                variant="caption" 
                color="textSecondary" 
                sx={{ 
                  fontSize: '0.85rem',
                  lineHeight: 1.5,
                  display: 'block'
                }}
              >
                승인된 관리자 및 열람자만 접근 가능합니다
              </Typography>
              <Typography 
                variant="caption" 
                color="primary" 
                sx={{ 
                  fontSize: '0.8rem',
                  mt: 1,
                  display: 'block'
                }}
              >
                문의: mark4mission@gmail.com
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default LoginPage;
